/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ZipLookupResult
 */
export interface ZipLookupResult {
    /**
     * 
     * @type {string}
     * @memberof ZipLookupResult
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ZipLookupResult
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof ZipLookupResult
     */
    county: string;
}

/**
 * Check if a given object implements the ZipLookupResult interface.
 */
export function instanceOfZipLookupResult(value: object): value is ZipLookupResult {
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('county' in value) || value['county'] === undefined) return false;
    return true;
}

export function ZipLookupResultFromJSON(json: any): ZipLookupResult {
    return ZipLookupResultFromJSONTyped(json, false);
}

export function ZipLookupResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZipLookupResult {
    if (json == null) {
        return json;
    }
    return {
        
        'city': json['city'],
        'state': json['state'],
        'county': json['county'],
    };
}

export function ZipLookupResultToJSON(json: any): ZipLookupResult {
    return ZipLookupResultToJSONTyped(json, false);
}

export function ZipLookupResultToJSONTyped(value?: ZipLookupResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'city': value['city'],
        'state': value['state'],
        'county': value['county'],
    };
}

